/** Environment metadata appended to feedback / bug reports (contact + FAB). */

export function getFeedbackEnv(themeName) {
  const ua = navigator.userAgent;
  let browser = "Unknown";
  if (ua.includes("Firefox/")) browser = "Firefox";
  else if (ua.includes("Edg/")) browser = "Edge";
  else if (ua.includes("Chrome/")) browser = "Chrome";
  else if (ua.includes("Safari/")) browser = "Safari";

  let os = "Unknown";
  if (ua.includes("Mac OS")) os = "macOS";
  else if (ua.includes("Windows")) os = "Windows";
  else if (ua.includes("Linux")) os = "Linux";
  else if (/iPhone|iPad/.test(ua)) os = "iOS";
  else if (ua.includes("Android")) os = "Android";

  return {
    url: window.location.href,
    userAgent: `${browser} / ${os}`,
    viewport: `${window.innerWidth} x ${window.innerHeight}`,
    screenResolution: `${screen.width} x ${screen.height}`,
    theme: themeName || "unknown",
    brand: import.meta.env.VITE_APP_BRAND || "webinarvault",
  };
}
